'use client'

import { useEffect } from 'react'
import {
  COOKIE_CONSENT_CHANGED_EVENT,
  COOKIE_CONSENT_STORAGE_KEY,
  type CookieConsentChoices,
} from './cookieConsentCatalog'
import { getCookieConsentChoices } from '@/utils/cookieConsentStorage'
import { applyGtagConsentUpdate } from './gtagConsent'

export function GoogleConsentSync() {
  useEffect(() => {
    applyGtagConsentUpdate(getCookieConsentChoices())

    const onConsentChanged = (event: Event) => {
      const customEvent = event as CustomEvent<CookieConsentChoices>
      if (!customEvent.detail) return
      applyGtagConsentUpdate(customEvent.detail)
    }

    const onStorageChanged = (event: StorageEvent) => {
      if (event.key !== COOKIE_CONSENT_STORAGE_KEY) return
      applyGtagConsentUpdate(getCookieConsentChoices())
    }

    window.addEventListener(COOKIE_CONSENT_CHANGED_EVENT, onConsentChanged)
    window.addEventListener('storage', onStorageChanged)

    return () => {
      window.removeEventListener(COOKIE_CONSENT_CHANGED_EVENT, onConsentChanged)
      window.removeEventListener('storage', onStorageChanged)
    }
  }, [])

  return null
}
